const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function getToken() {
  return localStorage.getItem('token');
}

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json();

  if (!res.ok) {
    const err = new Error(data.erro || 'Erro desconhecido.');
    err.detalhes = data;
    throw err;
  }

  return data;
}

export const api = {
  login:            (email, senha)       => request('POST',  '/auth/login',             { email, senha }),
  getOrdens:        ()                   => request('GET',   '/ordens'),
  getPendentesData: ()                   => request('GET',   '/itens/pendentes-data'),
  liberarDataEntrega: (numero, dataEntrega) => request('PATCH', `/itens/${numero}/data-entrega`, { data_entrega: dataEntrega }),
  getOrdensConcluidas: (dias)           => request('GET',   `/ordens/concluidas${dias ? '?dias=' + dias : ''}`),
  getItem:          (numero)             => request('GET',   `/itens/${numero}`),
  bipar: (numero, acao, tipoImpressao, proximoSetorDigital, proximoSetorAtendimento, precisaCartela, tipoCartela, proximoSetorAcabamento, proximoSetorFora, destinoDireto, proximoSetorCorte, proximoSetorImpressaoDigital, arteFinalistaResponsavel) => {
    const body = { acao };
    if (tipoImpressao) body.tipo_impressao = tipoImpressao;
    if (proximoSetorDigital) body.proximo_setor_digital = proximoSetorDigital;
    if (proximoSetorAtendimento) body.proximo_setor_atendimento = proximoSetorAtendimento;
    if (arteFinalistaResponsavel) body.arte_finalista_responsavel = arteFinalistaResponsavel;
    if (precisaCartela !== undefined && precisaCartela !== null) body.precisa_cartela = precisaCartela;
    if (tipoCartela) body.tipo_cartela = tipoCartela;
    if (proximoSetorAcabamento) body.proximo_setor_acabamento = proximoSetorAcabamento;
    if (proximoSetorFora) body.proximo_setor_fora = proximoSetorFora;
    if (destinoDireto) body.destino_direto = destinoDireto;
    if (proximoSetorCorte) body.proximo_setor_corte = proximoSetorCorte;
    if (proximoSetorImpressaoDigital) body.proximo_setor_impressao_digital = proximoSetorImpressaoDigital;
    return request('PATCH', `/itens/${numero}/bipar`, body);
  },
  getProcessos:     (numero)             => request('GET',   `/itens/${numero}/processos`),
  atualizarProcesso:    (numero, processo, concluido) => request('PATCH', `/itens/${numero}/processos`,    { processo, concluido }),
  atualizarObservacao:  (numero, observacao)          => request('PATCH', `/itens/${numero}/observacao`,   { observacao }),
  retrograde:       (numero, motivo)      => request('PATCH', `/itens/${numero}/retrograde`, { motivo }),
  getOrdem:         (numero, incluirConcluidos) => request('GET',    `/ordens/${numero}${incluirConcluidos ? '?incluirConcluidos=true' : ''}`),
  buscarHistorico:  (params)             => request('GET',    `/ordens/historico?${new URLSearchParams(params)}`),
  criarOrdem:       (numero, cliente, itens, email, telefone) => request('POST',   '/ordens', { numero, cliente, itens, email, telefone }),
  deletarOrdem:     (numero)             => request('DELETE', `/ordens/${numero}`),
  deletarItem:      (numero)             => request('DELETE', `/itens/${numero}`),
  atualizarNome:    (nome)               => request('PATCH',  '/usuarios/me', { nome }),
  getUsuarios:      ()                   => request('GET',    '/usuarios'),
  criarUsuario:     (dados)              => request('POST',   '/usuarios', dados),
  atualizarUsuario: (id, dados)          => request('PATCH',  `/usuarios/${id}`, dados),
  deletarUsuario:   (id)                 => request('DELETE', `/usuarios/${id}`),
  getRelatorios:    ()                   => request('GET',    '/relatorios/tempos'),
  getTransicoes:    ()                   => request('GET',    '/relatorios/transicoes'),
  getBipagens:      ()                   => request('GET',    '/relatorios/bipagens'),
  buscarPedidoPDV:  (numero)             => request('GET',    `/pdv/pedido/${numero}`),
  reconciliarOrdem: (numero)             => request('POST',   `/ordens/${numero}/reconciliar`),
  getAnotacoes:     (numero)             => request('GET',    `/itens/${numero}/anotacoes`),
  adicionarAnotacao:(numero, texto)      => request('POST',   `/itens/${numero}/anotacoes`, { texto }),
  deletarAnotacao:  (numero, id)         => request('DELETE', `/itens/${numero}/anotacoes/${id}`),
  getConfiguracoes: ()                   => request('GET',    '/configuracoes'),
  salvarConfiguracoes: (dados)           => request('PATCH',  '/configuracoes', dados),
  buscarChapa:      (numero)             => request('POST',   `/itens/${numero}/chapa`),
  confirmarCartela: (numero)             => request('POST',   `/itens/${numero}/cartela`),
  cancelarCartela:  (numero)             => request('DELETE', `/itens/${numero}/cartela`),
};
